export class MessageConstants {
  static readonly success = 'SUCCESS';
  static readonly failed = 'ERROR';
  static readonly warning = 'WARNING';
  static readonly cannotAddQuestion =
    'Something went wrong! You cannot add a question for this field';
  static readonly scheduleUpdated = 'Schedule Settings Updated';
  static readonly unexpectedError = 'Unexpected Error';
  static readonly credentialCreated = 'Payer Credential Created';
  static readonly credentialUpdated = 'Payer Credential Updated';
  static readonly credentialDeleted = 'Payer Credential Deleted';
  static readonly providerCreated = 'Provider Created';
  static readonly defaultProviderCreated = 'Default Provider Created';
  static readonly defaultProviderUpdated = 'Default Provider Updated';
  static readonly defaultProviderDeleted = 'Provider removed from default provider';
  static readonly connectorCreated = 'Added new connector';
  static readonly connectorAlreadyAdded = 'Connector already added';
  static readonly IntegretorAlreadyAdded = 'Integrator already added';
  static readonly connectorCreationFailed = 'Failed to add connector';
  static readonly connectorEdited = 'Connector Details Edited';
  static readonly connectorEditFailed = 'Failed to edit connector details';
  static readonly customerKeyFetchFailed = 'Failed to get customer key';
  static readonly noConnectorKeyAvailable = 'No connector key available';
  static readonly openDentalClinicFetchFailed = 'Failed to get Open Dental Clinics';
  static readonly failedToDownload = 'Failed to Download File, try again later';
  static readonly keyRevoked = 'Key Revoked';
  static readonly keyCopied = 'Key Copied to Clipboard';
  static readonly otpCopied = 'MFA Code Copied to Clipboard';
  static readonly noOTPCopied = 'No MFA Code to copy';
  static readonly noteFailed = 'Enter a comment';
  static readonly noteCreated = 'Comment added';
  static readonly noteDeleted = 'Comment deleted';
  static readonly noteEdited = 'Comment edited';
  static readonly questionAlreadyCreated = 'There is already a question created for this field';
  static readonly benefitAvailable = 'Benefit already available.';
  static readonly benefitNotAvailable = 'Chosen benefit is not available.';
  static readonly benefitSaved = 'Benefit saved successfully.';
  static readonly benefitDeleted = 'Benefit deleted successfully.';
  static readonly benefitAlreadyExists = 'Benefit already exists';
  static readonly eligibilityRunTriggered = 'Eligibility run scheduled successfully!';
  static readonly credentialCopied = 'Payer Credential Copied';
  static readonly providerActivated = 'Provider Activated Successfully';
  static readonly providerDeactivated = 'Provider Deactivated Successfully';
  static readonly providerUpdate = 'Provider updated successfully';
  static readonly defaultProviderCreate = 'Default provider created successfully';
  static readonly payersAssigned = 'Payers assigned to provider successfully';
  static readonly defaultProviderwithPayers = 'Default provider with payers created successfully';
  static readonly normalProviderCreate = 'Provider created successfully';
  static readonly updateQuestionFailed = 'Failed to update question, try again later';
  static readonly missingInsuranceData = 'Missing eligibility insurance data';
  static readonly multipleActiveTemplatesFailed =
    'Failed to activate template. You can not have more than one active template for the same payer';
  static readonly deleteQuestionFailed = 'Failed to delete question, try again later';
  static readonly deleteRequestFailed = 'Failed to delete request, try again later';
  static readonly questionTooLongFailed = 'The question is too long';
  static readonly noPayerSelected = 'You need to select at least one payer';
  static readonly eligibilityTitleMessageMap = {
    Pending: 'Eligibility check is yet to run.',
    InProgress: 'Eligibility check in progress...',
    Error: 'Uh oh! Enhanced Eligibility Check Failed.',
    Verified: 'Eligibility check verified!'
  };
  static readonly eligibilitySubtitleMessageMap = {
    Pending: 'Please check your schedule settings.',
    InProgress: 'Please try again later.',
    Error: 'Please manually re-run the check.',
    Verified: 'Please check the eligibility details.'
  };
  static readonly syncErrorTitleMessageMap = {
    BatchFailed: 'Appointment Sync Failed',
    Failed: 'Appointment Sync Failed',
    Invalid: 'Appointment Missing Data',
    Success: 'Appointment Success',
    NoInsurance: 'Appointment Missing Data'
  };
  static readonly syncErrorSubtitleMessageMap = {
    BatchFailed: 'We are processing your appointment. Kindly wait for sometime.',
    Failed: 'Saving this appointment has failed due to errors. Kindly retry.',
    Invalid:
      'Please update the patient record in your Practice Management Software to correct the errors. The information will be automatically synced within a few minutes once updated.',
    Success: '',
    NoInsurance:
      'Please update the patient record in your Practice Management Software to correct the errors. The information will be automatically synced within a few minutes once updated.'
  };
  static readonly testConnectionMessageMap = {
    Success: 'Test connection passed',
    Failed: 'Failed to connect'
  };
  static readonly embedMessageToParent = {
    ComponentLoaded: 'Component has been loaded',
    Failed: 'Failed to show Eligibility Logs',
    SessionInvalid: 'Session expired or invalid',
    UnexpectedError: 'An unexpected error occurred',
    eligibilityLogsFailed: 'Failed to show Eligibility Logs',
    newEligibilityFailed: 'Failed to create Eligibility',
    eligibilityEditFailed: 'Failed to edit Eligibility',
    eligibilityCheckFailed: 'Failed to check Eligibility'
  };
  static readonly fileDownloaded = 'File downloaded successfully';
  static readonly failedFetch = 'Failed to load the data, try again later';
  static readonly otpGenerationFailed = 'Please enter a valid Authenticator Key';
  static readonly mfaCodeCopied = 'MFA code copied successfully';
  static readonly mfaContactCopied = 'MFA Contact copied successfully';
  static readonly phoneRequest = {
    success: 'Phone Number received successfully',
    failed: 'Failed to get a Phone Number'
  };
  static readonly emailRequest = {
    success: 'Email ID received successfully',
    failed: 'Failed to get an Email ID'
  };
  static readonly nonClientFriendlyErrorMessage =
    'DentalXChange will resolve this error and resend the eligibility request';
  static readonly providerAlreadyCreated =
    'This provider already exists. Please use the Provider Edit feature to update the existing provider';
}
